import partyService from "../services/partyService";

export default {
    namespaced: true,

    state: {
        channels: [],
        users: [],
        recipientParties: [],
    },

    mutations: {
        updateChannels(state, channels) {
            state.channels = [...channels];

        },
        updateUsers(state, users) {
            state.users = users
        },
        updateRecipientParties: (state, recipientParties) => {
            state.recipientParties = recipientParties;
        },
    },

    getters: {
        channels: state => state.channels,
        users: state => state.users,
        recipientParties: state => state.recipientParties,
    },

    actions: {
        async updateRecipientParties({commit}) {
            const parties = await partyService.getChatParties();
            commit('updateRecipientParties', parties);
        },
    },
};
  